import { DropdownOption } from "../../../assets/vfx/controls/components/dropdown/controlDropdown";

export const RSSFEED_TYPE = {
  NEWS: "59ce97e0-510b-f011-8ef4-00155d112802",
  EVENTS: "d5a03be9-510b-f011-8ef4-00155d112802",
};

const titles: Record<string, string> = {
  [RSSFEED_TYPE.NEWS]: "News RSS Feed",
  [RSSFEED_TYPE.EVENTS]: "Events RSS Feed",
};

export const getTitle = (rssfeedTypeId?: string): string => {
  return titles[rssfeedTypeId ?? ""] || "RSS Feed";
};

export const getRssFeedOptions = (): DropdownOption[] => {
  return Object.entries(titles).map(([key, title]) => ({
    key,
    display: `${title}s`,
    value: key,
  }));
};
